/* START_MODULE_CONTRACT
 * PURPOSE: Обёртка LocalizationProvider с русской локалью dayjs для полей даты.
 * SCOPE: LocalizationProvider, AdapterDayjs, locale ru.
 * DEPENDS: @mui/x-date-pickers, dayjs
 * LINKS: M-FE-APP
 * ROLE: RUNTIME
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * AppLocalizationProvider - провайдер локали для DatePicker.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Русская локаль и dayjs-адаптер для календаря.
 * END_CHANGE_SUMMARY
 */

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

/* START_METHOD_AppLocalizationProvider */
/* START_CONTRACT: AppLocalizationProvider
 * PURPOSE: Обернуть приложение провайдером дат MUI X.
 * INPUTS: { children: React.ReactNode }.
 * OUTPUTS: { JSX.Element }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: AppLocalizationProvider
 */
export default function AppLocalizationProvider({ children }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      {children}
    </LocalizationProvider>
  );
}
/* END_METHOD_AppLocalizationProvider */
